
<div class="main-component-container main-margin" [class]="'container-' + contactsMode">

  <div class="contacts-panel">
    <div class="page-header" [class]="'page-header-' + contactsMode">
      <div [class]="'page-header-left-container-' + contactsMode" class="page-header-left-container">
        <img (click)="selectedContactFunc(null)" *ngIf="contactsMode == ContactsMode.SELECT" class="component-header-back-arrow-icon hover-icon" src="../../../assets/generic/back_arrow_white.svg">

        <div class="contacts-title-block">
          <p class="page-header-text">{{contactsMode == ContactsMode.REGULAR ? "Contacts" : "Select Contact"}}</p>
          <p *ngIf="contactsMode == ContactsMode.REGULAR" class="contacts-subtitle">
            {{(userAuthService.currentUserComplete?.userContacts?.length || 0)}} saved contact{{(userAuthService.currentUserComplete?.userContacts?.length || 0) == 1 ? '' : 's'}}
          </p>
        </div>

        <!--Filler for justify content-->
        <div *ngIf="contactsMode == ContactsMode.SELECT"></div>
      </div>
      <div class="page-header-right-container" *ngIf="contactsMode == ContactsMode.REGULAR">
        <button *ngIf="!tutorialService.isAddContactTutorialActive" type="button" class="members-tutorial-button" (click)="startTutorial()">
          {{ 'Start Tutorial' | translate }}
        </button>
        <button class="circle-button primary-light-button" (click)="onAddContactClick()" data-tutorial-target="contacts-add-btn"><img src="assets/generic/plus_icon.svg"></button>
      </div>
    </div>

    <div class="page-content-container">
      <ng-container *ngIf="userAuthService.currentUserComplete?.userContacts?.length; else emptyContactsState">
        <div (click)="selectedContactFunc(contact)" *ngFor="let contact of userAuthService.currentUserComplete?.userContacts; let last = last" class="contact-row" [class.contact-row-deleted]="contact.status == UserContactStatus.DELETED">
          <div class="contact-row-main">
            <p class="contact-nickname">{{contact.nickname}}</p>
            <p class="contact-status-pill" *ngIf="contact.status == UserContactStatus.DELETED">Deleted</p>
          </div>
          <img *ngIf="contact.status == UserContactStatus.DELETED" class="contact-deleted-badge" src="../../../assets/generic/cancel.svg">
        </div>
      </ng-container>

      <ng-template #emptyContactsState>
        <div class="empty-contacts-state">
          <p class="empty-contacts-title">No contacts yet</p>
          <p class="empty-contacts-text">Add a contact to get started.</p>
        </div>
      </ng-template>
    </div>
  </div>

</div>



